import { render, staticRenderFns } from "./DashboardSchedule.vue?vue&type=template&id=5ca070b4"
import script from "./DashboardSchedule.vue?vue&type=script&lang=js"
export * from "./DashboardSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports